import { Component } from 'react';
import { withTranslation} from "react-i18next";

import {withSuspense} from './util/WithSuspense.js';

class NadheoPerformanceStatus extends Component {
  // props contain 
  // - status: the performance status
  // - closing_date: the performance possible closing date
  // - opening_date: the performance possible opening date
  // - free_seats: the number of seats remaining to be sold
  render() {
    const { t } = this.props;
    switch(this.props.status) {
      case "not published": 
      case "cancelled":
      case "probably sold out":
      case "sold out":
      case "closed":
        return t("performancestatus_"+this.props.status);
      case "announced": 
        let openingDate = { timezone: this.props.timezone, date: this.props.opening_date};
        return t("performancestatus_"+this.props.status, {date:openingDate});
      case "open":          
        return t("performancestatus_"+this.props.status, {count:this.props.free_seats});
      default: return this.props.status;
    }
  }

}

export default withSuspense("", withTranslation("booking")(NadheoPerformanceStatus));
